export const itemsSelect = {

    admin_search_commandes_by_mode() {
        let list = [];
        list.push({ title: "Email de l'utilisateur", value: "email" });
        list.push({ title: "Nom de l'inscrit", value: "nom" });
        list.push({ title: "UUID de la commande", value: "uuid" });
        list.push({ title: "ID de l'utilisateur", value: "id_user" });
        return list;
    },
    admin_search_refund_commandes_by_mode() {
        let list = [];
        list.push({ title: "Email de l'utilisateur", value: "email" });
        list.push({ title: "Nom de l'inscrit", value: "nom" });
        list.push({ title: "UUID de la commande", value: "uuid" });
        return list;
    },
    refund_fee_payed_by() {
        let list = [];
        list.push({ title: "Organisateur", value: "orga" });
        list.push({ title: "Participant", value: "participant" });
        return list;
    },

    inscriptions_search_by() {
        let list = [
            { title: "Identité", value: "nom" },
            { title: "Mail", value: "mail" },
            { title: "Référence commande", value: "search_commande" }
        ];

        return list;
    },

    order_by_select(is_admin = false) {
        let list = [];
        list.push({ title: "Nom", value: "nom" });
        list.push({ title: "Dossard", value: "dossard" });
        list.push({ title: "Club", value: "club" });
        if (is_admin) {
            list.push({ title: "SAS de départ", value: "vague" });
            list.push({ title: "Dernière inscription", value: "last_inscription" });
        }
        return list;
    },

    order_by_preinscription_select() {
        let list = [];
        list.push({ title: "Date d'inscription", value: "id" });
        list.push({ title: "Nom", value: "nom" });
        list.push({ title: "Club", value: "club" });
        return list;
    },

    getSelection(options, is_ffrp = false, is_multiple = false) {
        let list = [];
        let list_options = options.split(";");
        if (list_options.length > 0 && !list_options[0].includes("Sélect") && !is_multiple) {
            list.push({ title: "Sélectionner", value: "" });
        }

        for (let i = 0; i < list_options.length; i++) {
            if (is_ffrp && is_ffrp == '1' && list_options[i] == 'Licence') {
                list.push({ title: list_options[i] + " FFRP", value: list_options[i] });
            }
            else {
                list.push({ title: list_options[i], value: list_options[i] });
            }
        }
        return list;
    },

    sexe() {
        let list_sexe = [];
        list_sexe.push({ title: "Homme", value: "M" });
        list_sexe.push({ title: "Femme", value: "F" });
        return list_sexe;
    },
    mode_livraison() {
        let list_mode_livraison = [];
        list_mode_livraison.push({ title: "Retrait sur place", value: "retrait" });
        list_mode_livraison.push({ title: "Retrait en point relais pickup", value: "point_relai" });
        return list_mode_livraison;
    },

    options_days() {
        let list_days = [
            { label: "01", value: "01" },
            { label: "02", value: "02" },
            { label: "03", value: "03" },
            { label: "04", value: "04" },
            { label: "05", value: "05" },
            { label: "06", value: "06" },
            { label: "07", value: "07" },
            { label: "08", value: "08" },
            { label: "09", value: "09" },
            { label: "10", value: "10" },
            { label: "11", value: "11" },
            { label: "12", value: "12" },
            { label: "13", value: "13" },
            { label: "14", value: "14" },
            { label: "15", value: "15" },
            { label: "16", value: "16" },
            { label: "17", value: "17" },
            { label: "18", value: "18" },
            { label: "19", value: "19" },
            { label: "20", value: "20" },
            { label: "21", value: "21" },
            { label: "22", value: "22" },
            { label: "23", value: "23" },
            { label: "24", value: "24" },
            { label: "25", value: "25" },
            { label: "26", value: "26" },
            { label: "27", value: "27" },
            { label: "28", value: "28" },
            { label: "29", value: "29" },
            { label: "30", value: "30" },
            { label: "31", value: "31" }
        ];
        return list_days;
    },
    options_months() {
        let list_months = [
            { label: "Janvier", value: "01" },
            { label: "Février", value: "02" },
            { label: "Mars", value: "03" },
            { label: "Avril", value: "04" },
            { label: "Mai", value: "05" },
            { label: "Juin", value: "06" },
            { label: "Juillet", value: "07" },
            { label: "Août", value: "08" },
            { label: "Septembre", value: "09" },
            { label: "Octobre", value: "10" },
            { label: "Novembre", value: "11" },
            { label: "Décembre", value: "12" }
        ]
        return list_months;
    },

    options_years() {
        let list_years = [];
        let current_year = new Date().getFullYear();
        for (let i = current_year; i > 1900; i--) {
            list_years.push({ label: i, value: i });
        }
        return list_years;
    },

    pays() {
        let list_pays = [
            {
                "title": "Afghanistan",
                "value": "AFG"
            },
            {
                "title": "Afrique du Sud",
                "value": "ZAF"
            },
            {
                "title": "Albanie",
                "value": "ALB"
            },
            {
                "title": "Algérie",
                "value": "DZA"
            },
            {
                "title": "Allemagne",
                "value": "DEU"
            },
            {
                "title": "Andorre",
                "value": "AND"
            },
            {
                "title": "Angola",
                "value": "AGO"
            },
            {
                "title": "Anguilla",
                "value": "AIA"
            },
            {
                "title": "Antarctique",
                "value": "ATA"
            },
            {
                "title": "Antigua-et-Barbuda",
                "value": "ATG"
            },
            {
                "title": "Antilles Néerlandaises",
                "value": "ANT"
            },
            {
                "title": "Arabie Saoudite",
                "value": "SAU"
            },
            {
                "title": "Argentine",
                "value": "ARG"
            },
            {
                "title": "Arménie",
                "value": "ARM"
            },
            {
                "title": "Aruba",
                "value": "ABW"
            },
            {
                "title": "Australie",
                "value": "AUS"
            },
            {
                "title": "Autriche",
                "value": "AUT"
            },
            {
                "title": "Azerbaïdjan",
                "value": "AZE"
            },
            {
                "title": "Bahamas",
                "value": "BHS"
            },
            {
                "title": "Bahreïn",
                "value": "BHR"
            },
            {
                "title": "Bangladesh",
                "value": "BGD"
            },
            {
                "title": "Barbade",
                "value": "BRB"
            },
            {
                "title": "Belgique",
                "value": "BEL"
            },
            {
                "title": "Belize",
                "value": "BLZ"
            },
            {
                "title": "Bermudes",
                "value": "BMU"
            },
            {
                "title": "Bhoutan",
                "value": "BTN"
            },
            {
                "title": "Bolivie",
                "value": "BOL"
            },
            {
                "title": "Bosnie-Herzégovine",
                "value": "BIH"
            },
            {
                "title": "Botswana",
                "value": "BWA"
            },
            {
                "title": "Brunéi Darussalam",
                "value": "BRN"
            },
            {
                "title": "Brésil",
                "value": "BRA"
            },
            {
                "title": "Bulgarie",
                "value": "BGR"
            },
            {
                "title": "Burkina Faso",
                "value": "BFA"
            },
            {
                "title": "Burundi",
                "value": "BDI"
            },
            {
                "title": "Bélarus",
                "value": "BLR"
            },
            {
                "title": "Bénin",
                "value": "BEN"
            },
            {
                "title": "Cambodge",
                "value": "KHM"
            },
            {
                "title": "Cameroun",
                "value": "CMR"
            },
            {
                "title": "Canada",
                "value": "CAN"
            },
            {
                "title": "Cap-vert",
                "value": "CPV"
            },
            {
                "title": "Chili",
                "value": "CHL"
            },
            {
                "title": "Chine",
                "value": "CHN"
            },
            {
                "title": "Chypre",
                "value": "CYP"
            },
            {
                "title": "Colombie",
                "value": "COL"
            },
            {
                "title": "Comores",
                "value": "COM"
            },
            {
                "title": "Congo, République",
                "value": "COG"
            },
            {
                "title": "Congo, République Démocratique",
                "value": "COD"
            },
            {
                "title": "Corée, République",
                "value": "KOR"
            },
            {
                "title": "Corée, République Populaire Démocratique",
                "value": "PRK"
            },
            {
                "title": "Costa Rica",
                "value": "CRI"
            },
            {
                "title": "Croatie",
                "value": "HRV"
            },
            {
                "title": "Cuba",
                "value": "CUB"
            },
            {
                "title": "Côte d'Ivoire",
                "value": "CIV"
            },
            {
                "title": "Danemark",
                "value": "DNK"
            },
            {
                "title": "Djibouti",
                "value": "DJI"
            },
            {
                "title": "Dominique",
                "value": "DMA"
            },
            {
                "title": "Égypte",
                "value": "EGY"
            },
            {
                "title": "El Salvador",
                "value": "SLV"
            },
            {
                "title": "Émirats Arabes Unis",
                "value": "ARE"
            },
            {
                "title": "Équateur",
                "value": "ECU"
            },
            {
                "title": "Érythrée",
                "value": "ERI"
            },
            {
                "title": "Espagne",
                "value": "ESP"
            },
            {
                "title": "Estonie",
                "value": "EST"
            },
            {
                "title": "États Fédérés de Micronésie",
                "value": "FSM"
            },
            {
                "title": "États-Unis",
                "value": "USA"
            },
            {
                "title": "Éthiopie",
                "value": "ETH"
            },
            {
                "title": "Fidji",
                "value": "FJI"
            },
            {
                "title": "Finlande",
                "value": "FIN"
            },
            {
                "title": "France",
                "value": "FRA"
            },
            {
                "title": "Gabon",
                "value": "GAB"
            },
            {
                "title": "Gambie",
                "value": "GMB"
            },
            {
                "title": "Ghana",
                "value": "GHA"
            },
            {
                "title": "Gibraltar",
                "value": "GIB"
            },
            {
                "title": "Grenade",
                "value": "GRD"
            },
            {
                "title": "Groenland",
                "value": "GRL"
            },
            {
                "title": "Grèce",
                "value": "GRC"
            },
            {
                "title": "Guadeloupe",
                "value": "GLP"
            },
            {
                "title": "Guam",
                "value": "GUM"
            },
            {
                "title": "Guatemala",
                "value": "GTM"
            },
            {
                "title": "Guinée",
                "value": "GIN"
            },
            {
                "title": "Guinée Équatoriale",
                "value": "GNQ"
            },
            {
                "title": "Guinée-Bissau",
                "value": "GNB"
            },
            {
                "title": "Guyane",
                "value": "GUY"
            },
            {
                "title": "Guyane Française",
                "value": "GUF"
            },
            {
                "title": "Géorgie",
                "value": "GEO"
            },
            {
                "title": "Haïti",
                "value": "HTI"
            },
            {
                "title": "Honduras",
                "value": "HND"
            },
            {
                "title": "Hong-Kong",
                "value": "HKG"
            },
            {
                "title": "Hongrie",
                "value": "HUN"
            },
            {
                "title": "Île Bouvet",
                "value": "BVT"
            },
            {
                "title": "Île Christmas",
                "value": "CXR"
            },
            {
                "title": "Île Norfolk",
                "value": "NFK"
            },
            {
                "title": "Îles Caïmanes",
                "value": "CYM"
            },
            {
                "title": "Îles Cocos (Keeling)",
                "value": "CCK"
            },
            {
                "title": "Îles Cook",
                "value": "COK"
            },
            {
                "title": "Îles Féroé",
                "value": "FRO"
            },
            {
                "title": "Îles Malouines",
                "value": "FLK"
            },
            {
                "title": "Îles Mariannes du Nord",
                "value": "MNP"
            },
            {
                "title": "Îles Marshall",
                "value": "MHL"
            },
            {
                "title": "Îles Mineures Éloignées des États-Unis",
                "value": "UMI"
            },
            {
                "title": "Îles Salomon",
                "value": "SLB"
            },
            {
                "title": "Îles Turques-et-Caïques",
                "value": "TCA"
            },
            {
                "title": "Îles Vierges Britanniques",
                "value": "VGB"
            },
            {
                "title": "Îles Vierges des États-Unis",
                "value": "VIR"
            },
            {
                "title": "Inde",
                "value": "IND"
            },
            {
                "title": "Indonésie",
                "value": "IDN"
            },
            {
                "title": "Iran",
                "value": "IRN"
            },
            {
                "title": "Iraq",
                "value": "IRQ"
            },
            {
                "title": "Irlande",
                "value": "IRL"
            },
            {
                "title": "Islande",
                "value": "ISL"
            },
            {
                "title": "Israël",
                "value": "ISR"
            },
            {
                "title": "Italie",
                "value": "ITA"
            },
            {
                "title": "Jamaïque",
                "value": "JAM"
            },
            {
                "title": "Japon",
                "value": "JPN"
            },
            {
                "title": "Jordanie",
                "value": "JOR"
            },
            {
                "title": "Kazakhstan",
                "value": "KAZ"
            },
            {
                "title": "Kenya",
                "value": "KEN"
            },
            {
                "title": "Kirghizistan",
                "value": "KGZ"
            },
            {
                "title": "Kiribati",
                "value": "KIR"
            },
            {
                "title": "Koweït",
                "value": "KWT"
            },
            {
                "title": "Laos",
                "value": "LAO"
            },
            {
                "title": "Lesotho",
                "value": "LSO"
            },
            {
                "title": "Lettonie",
                "value": "LVA"
            },
            {
                "title": "Liban",
                "value": "LBN"
            },
            {
                "title": "Liberia",
                "value": "LBR"
            },
            {
                "title": "Libye",
                "value": "LBY"
            },
            {
                "title": "Liechtenstein",
                "value": "LIE"
            },
            {
                "title": "Lituanie",
                "value": "LTU"
            },
            {
                "title": "Luxembourg",
                "value": "LUX"
            },
            {
                "title": "Macao",
                "value": "MAC"
            },
            {
                "title": "Macédoine",
                "value": "MKD"
            },
            {
                "title": "Madagascar",
                "value": "MDG"
            },
            {
                "title": "Malaisie",
                "value": "MYS"
            },
            {
                "title": "Malawi",
                "value": "MWI"
            },
            {
                "title": "Maldives",
                "value": "MDV"
            },
            {
                "title": "Mali",
                "value": "MLI"
            },
            {
                "title": "Malte",
                "value": "MLT"
            },
            {
                "title": "Maroc",
                "value": "MAR"
            },
            {
                "title": "Martinique",
                "value": "MTQ"
            },
            {
                "title": "Maurice",
                "value": "MUS"
            },
            {
                "title": "Mauritanie",
                "value": "MRT"
            },
            {
                "title": "Mayotte",
                "value": "MYT"
            },
            {
                "title": "Mexique",
                "value": "MEX"
            },
            {
                "title": "Moldavie",
                "value": "MDA"
            },
            {
                "title": "Monaco",
                "value": "MCO"
            },
            {
                "title": "Mongolie",
                "value": "MNG"
            },
            {
                "title": "Montserrat",
                "value": "MSR"
            },
            {
                "title": "Mozambique",
                "value": "MOZ"
            },
            {
                "title": "Myanmar",
                "value": "MMR"
            },
            {
                "title": "Namibie",
                "value": "NAM"
            },
            {
                "title": "Nauru",
                "value": "NRU"
            },
            {
                "title": "Nicaragua",
                "value": "NIC"
            },
            {
                "title": "Niger",
                "value": "NER"
            },
            {
                "title": "Nigéria",
                "value": "NGA"
            },
            {
                "title": "Niue",
                "value": "NIU"
            },
            {
                "title": "Norvège",
                "value": "NOR"
            },
            {
                "title": "Nouvelle-Calédonie",
                "value": "NCL"
            },
            {
                "title": "Nouvelle-Zélande",
                "value": "NZL"
            },
            {
                "title": "Népal",
                "value": "NPL"
            },
            {
                "title": "Oman",
                "value": "OMN"
            },
            {
                "title": "Ouganda",
                "value": "UGA"
            },
            {
                "title": "Ouzbékistan",
                "value": "UZB"
            },
            {
                "title": "Pakistan",
                "value": "PAK"
            },
            {
                "title": "Palaos",
                "value": "PLW"
            },
            {
                "title": "Panama",
                "value": "PAN"
            },
            {
                "title": "Papouasie-Nouvelle-Guinée",
                "value": "PNG"
            },
            {
                "title": "Paraguay",
                "value": "PRY"
            },
            {
                "title": "Pays-Bas",
                "value": "NLD"
            },
            {
                "title": "Philippines",
                "value": "PHL"
            },
            {
                "title": "Pitcairn",
                "value": "PCN"
            },
            {
                "title": "Pologne",
                "value": "POL"
            },
            {
                "title": "Polynésie Française",
                "value": "PYF"
            },
            {
                "title": "Porto Rico",
                "value": "PRI"
            },
            {
                "title": "Portugal",
                "value": "PRT"
            },
            {
                "title": "Pérou",
                "value": "PER"
            },
            {
                "title": "Qatar",
                "value": "QAT"
            },
            {
                "title": "Roumanie",
                "value": "ROU"
            },
            {
                "title": "Royaume-Uni",
                "value": "GBR"
            },
            {
                "title": "Rwanda",
                "value": "RWA"
            },
            {
                "title": "République Arabe Syrienne",
                "value": "SYR"
            },
            {
                "title": "République Centrafricaine",
                "value": "CAF"
            },
            {
                "title": "République Tchèque",
                "value": "CZE"
            },
            {
                "title": "Réunion",
                "value": "REU"
            },
            {
                "title": "Sahara Occidental",
                "value": "ESH"
            },
            {
                "title": "Saint-Barthélemy",
                "value": "BLM"
            },
            {
                "title": "Saint-Kitts-et-Nevis",
                "value": "KNA"
            },
            {
                "title": "Saint-Marin",
                "value": "SMR"
            },
            {
                "title": "Saint-Martin (partie Française)",
                "value": "MAF"
            },
            {
                "title": "Saint-Martin (partie Néerlandaise)",
                "value": "SXM"
            },
            {
                "title": "Saint-Pierre-et-Miquelon",
                "value": "SPM"
            },
            {
                "title": "Saint-Siège (Vatican)",
                "value": "VAT"
            },
            {
                "title": "Saint-Vincent-et-les Grenadines",
                "value": "VCT"
            },
            {
                "title": "Sainte-Hélène",
                "value": "SHN"
            },
            {
                "title": "Sainte-Lucie",
                "value": "LCA"
            },
            {
                "title": "Samoa",
                "value": "WSM"
            },
            {
                "title": "Samoa Américaines",
                "value": "ASM"
            },
            {
                "title": "Sao Tomé-et-Principe",
                "value": "STP"
            },
            {
                "title": "Serbie-et-Monténégro",
                "value": "SCG"
            },
            {
                "title": "Seychelles",
                "value": "SYC"
            },
            {
                "title": "Sierra Leone",
                "value": "SLE"
            },
            {
                "title": "Singapour",
                "value": "SGP"
            },
            {
                "title": "Slovaquie",
                "value": "SVK"
            },
            {
                "title": "Slovénie",
                "value": "SVN"
            },
            {
                "title": "Somalie",
                "value": "SOM"
            },
            {
                "title": "Soudan",
                "value": "SDN"
            },
            {
                "title": "Sri Lanka",
                "value": "LKA"
            },
            {
                "title": "Suisse",
                "value": "CHE"
            },
            {
                "title": "Suriname",
                "value": "SUR"
            },
            {
                "title": "Suède",
                "value": "SWE"
            },
            {
                "title": "Svalbard et Île Jan Mayen",
                "value": "SJM"
            },
            {
                "title": "Swaziland",
                "value": "SWZ"
            },
            {
                "title": "Sénégal",
                "value": "SEN"
            },
            {
                "title": "Tadjikistan",
                "value": "TJK"
            },
            {
                "title": "Tanzanie",
                "value": "TZA"
            },
            {
                "title": "Taïwan",
                "value": "TWN"
            },
            {
                "title": "Tchad",
                "value": "TCD"
            },
            {
                "title": "Terres Australes Françaises",
                "value": "ATF"
            },
            {
                "title": "Territoire Britannique de l'Océan Indien",
                "value": "IOT"
            },
            {
                "title": "Thaïlande",
                "value": "THA"
            },
            {
                "title": "Timor Oriental",
                "value": "TLS"
            },
            {
                "title": "Togo",
                "value": "TGO"
            },
            {
                "title": "Tokelau",
                "value": "TKL"
            },
            {
                "title": "Tonga",
                "value": "TON"
            },
            {
                "title": "Trinité-et-Tobago",
                "value": "TTO"
            },
            {
                "title": "Tunisie",
                "value": "TUN"
            },
            {
                "title": "Turkménistan",
                "value": "TKM"
            },
            {
                "title": "Turquie",
                "value": "TUR"
            },
            {
                "title": "Tuvalu",
                "value": "TUV"
            },
            {
                "title": "Ukraine",
                "value": "UKR"
            },
            {
                "title": "Uruguay",
                "value": "URY"
            },
            {
                "title": "Vanuatu",
                "value": "VUT"
            },
            {
                "title": "Venezuela",
                "value": "VEN"
            },
            {
                "title": "Viet Nam",
                "value": "VNM"
            },
            {
                "title": "Wallis-et-Futuna",
                "value": "WLF"
            },
            {
                "title": "Yémen",
                "value": "YEM"
            },
            {
                "title": "Zambie",
                "value": "ZMB"
            },
            {
                "title": "Zimbabwe",
                "value": "ZWE"
            }


        ]
        return list_pays;
    },
    indicatif_pays() {
        let countryCodes = [
            { label: "🇫🇷 France (+33)", value: "+33" },
            { label: "🇧🇪 Belgique (+32)", value: "+32" },
            { label: "🇨🇭 Suisse (+41)", value: "+41" },
            { label: "🇨🇦 Canada (+1)", value: "+1" },
            { label: "🇺🇸 États-Unis (+1)", value: "+1" },
        ]
        return countryCodes;
    }
}

